(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chery-lc-purchase-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cs-lc-purchase-details')) {
    customElements.define('cs-lc-purchase-details', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.stock = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
        this.row = this.querySelector('[data-low-stock]');
        const options = { signal: this.controller.signal };
        const sync = () => {
          const form = document.getElementById(this.dataset.form);
          const input = form?.querySelector('[name="id"]');
          if (input) this.row.hidden = this.stock[input.value] !== true;
        };
        const onVariant = event => {
          if (event.detail?.sectionId && event.detail.sectionId !== this.dataset.section) return;
          if (event.type === 'product:variant-change' && !event.detail?.variant) {
            this.row.hidden = true;
            return;
          }
          sync();
        };
        document.addEventListener('product:variant-change', onVariant, options);
        document.addEventListener('variant:change', onVariant, options);
        document.addEventListener('change', () => requestAnimationFrame(sync), options);
        sync();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["chery-native-last-chance"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cs-native-last-chance')) {
    customElements.define('cs-native-last-chance', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = {signal: this.controller.signal};
        this.addEventListener('click', event => {
          if (event.target.closest('[data-cs-native-close]')) this.closeInfo(true);
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          event.preventDefault();
          event.stopPropagation();
          this.closeInfo(true);
        }, options);
        this.addEventListener('keyup', event => {
          if (event.key === 'Escape') event.stopPropagation();
        }, options);
        document.addEventListener('pointerdown', event => {
          if (!this.contains(event.target)) this.closeInfo(false);
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
      closeInfo(restoreFocus) {
        const details = this.querySelector('details');
        if (!details?.open) return;
        details.open = false;
        if (restoreFocus) details.querySelector('summary').focus({preventScroll:true});
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
